export default __webpack_public_path__ + "static/media/CTRL-N_30_10.567ce22c.svg";